var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { MAX_AVAILABILITY_BOUND_MS, MAX_DISPLAY_CONFLICT_DATES, } from '../constants/inviteeAvailability';
import moment from 'moment-timezone';
export var isDifferentEvent = function (draft, conflict) {
    if (!conflict.id) {
        var cStart = new Date(conflict.start.date_time).getTime();
        var cEnd = new Date(conflict.end.date_time).getTime();
        return cStart !== draft.start.getTime() || cEnd !== draft.end.getTime();
    }
    if (draft.uid && conflict.uid) {
        return draft.uid !== conflict.uid;
    }
    return String(draft.id) !== String(conflict.id);
};
export var formatConflictInstances = function (conflicts, locale) {
    var uniqueDates = __spreadArray([], __read(new Set(conflicts.map(function (conflict) { return conflict.start.date_time.slice(0, 10); }))), false).sort();
    var formatter = new Intl.DateTimeFormat(locale, {
        month: '2-digit',
        day: '2-digit',
    });
    var visibleDates = uniqueDates.slice(0, MAX_DISPLAY_CONFLICT_DATES);
    var dates = visibleDates
        .map(function (dateString) { return formatter.format(new Date("".concat(dateString, "T12:00:00"))); })
        .join(', ');
    return {
        dates: dates,
        moreCount: Math.max(0, uniqueDates.length - MAX_DISPLAY_CONFLICT_DATES),
    };
};
/**
 * Free/busy endpoints reject millisecond precision (e.g. `.000Z`).
 * Matches schedule MeetingRooms free-busy callers.
 */
export var formatFreeBusyIsoDateTime = function (value, timezone) {
    return value
        .clone()
        .tz(timezone)
        .toISOString()
        .replace(/.\d+Z$/g, 'Z');
};
export var getAvailabilityBoundDurationMs = function (_a) {
    var from = _a.from, to = _a.to;
    var fromMs = moment.parseZone(from).valueOf();
    var toMs = moment.parseZone(to).valueOf();
    return Math.max(0, toMs - fromMs);
};
export var isAvailabilityWindowWithinLimit = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, isAllDayEvent = _a.isAllDayEvent, timezone = _a.timezone;
    if (!startTime.isValid() || !endTime.isValid()) {
        return false;
    }
    if (isAllDayEvent) {
        var daySpan = endTime
            .clone()
            .tz(timezone)
            .startOf('day')
            .diff(startTime.clone().tz(timezone).startOf('day'), 'days');
        return daySpan === 0;
    }
    var _b = getAvailabilityBounds({
        startTime: startTime,
        endTime: endTime,
        isAllDayEvent: isAllDayEvent,
        timezone: timezone,
    }), from = _b.from, to = _b.to;
    var durationMs = getAvailabilityBoundDurationMs({ from: from, to: to });
    return durationMs > 0 && durationMs <= MAX_AVAILABILITY_BOUND_MS;
};
export var getAvailabilityBounds = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, isAllDayEvent = _a.isAllDayEvent, timezone = _a.timezone;
    if (!isAllDayEvent) {
        return {
            from: formatFreeBusyIsoDateTime(startTime, timezone),
            to: formatFreeBusyIsoDateTime(endTime, timezone),
        };
    }
    return {
        from: formatFreeBusyIsoDateTime(startTime.clone().startOf('day'), timezone),
        to: formatFreeBusyIsoDateTime(endTime.clone().startOf('day'), timezone),
    };
};
export var getInviteeEmailsForAvailability = function (invitees) {
    var emails = new Set();
    invitees.forEach(function (invitee) {
        var _a;
        var email = (_a = invitee.email) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (email) {
            emails.add(email);
        }
    });
    return __spreadArray([], __read(emails), false).sort();
};
export var buildAvailabilityTimeFetchKey = function (_a) {
    var from = _a.from, to = _a.to, recurrenceKey = _a.recurrenceKey, timezone = _a.timezone, isAllDayEvent = _a.isAllDayEvent, composerMode = _a.composerMode, eventId = _a.eventId, uid = _a.uid;
    return [
        from,
        to,
        recurrenceKey !== null && recurrenceKey !== void 0 ? recurrenceKey : '',
        timezone,
        isAllDayEvent ? 'all-day' : 'timed',
        composerMode,
        eventId !== null && eventId !== void 0 ? eventId : '',
        uid !== null && uid !== void 0 ? uid : '',
    ].join('::');
};
export var diffInviteeEmails = function (previous, current) {
    var currentSet = new Set(current);
    var added = current.filter(function (email) { return !previous.has(email); });
    var removed = __spreadArray([], __read(previous), false).filter(function (email) { return !currentSet.has(email); });
    return { added: added, removed: removed };
};
export var inviteeEmailSetsEqual = function (previous, current) {
    if (previous.size !== current.length) {
        return false;
    }
    return current.every(function (email) { return previous.has(email); });
};
export var filterConflictsForEditingEvent = function (conflictsMap, draft) {
    var filtered = new Map();
    conflictsMap.forEach(function (conflicts, email) {
        filtered.set(email, conflicts.filter(function (conflict) { return isDifferentEvent(draft, conflict); }));
    });
    return filtered;
};
